<template>
    <div class="data-evaluation-page">
        <!-- 企业信息 -->
        <el-card class="box-card" shadow="never">
            <div slot="header" class="clearfix">
                <span>企业信息</span>
            </div>
            <el-table :data="enterpriseInfoData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        {{ scope.row.value }}
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 数据资产信息 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据资产信息</span>
            </div>
            <el-table :data="dataAssetInfoData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        {{ scope.row.value }}
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 企业合规信息 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>企业合规信息</span>
            </div>
            <el-table :data="companyComplianceData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">

                        <div v-for="(item, index) in getFileList(scope.row.value)" :key="index" class="file-item">
                            {{ item }}

                            <el-button v-if="isPreviewable(item)" type="text" size="mini" @click="previewFile(item)"
                                style="margin-left: 8px;">
                                预览
                            </el-button>
                            <el-button type="text" size="small" @click="downloadFile(scope.row.value)">
                                下载
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 数据合规信息 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>数据合规信息</span>
            </div>
            <el-table :data="dataComplianceData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        <div v-for="(item, index) in getFileList(scope.row.value)" :key="index" class="file-item">
                            {{ item }}

                            <span v-if="item">
                                <el-button v-if="isPreviewable(item)" type="text" size="mini" @click="previewFile(item)"
                                    style="margin-left: 8px;">
                                    预览
                                </el-button>
                                <el-button type="text" size="small" @click="downloadFile(scope.row.value)">
                                    下载
                                </el-button>
                            </span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <!-- 合规审核结果 -->
        <el-card class="box-card" shadow="never" style="margin-top: 20px;">
            <div slot="header" class="clearfix">
                <span>合规审核结果</span>
            </div>
            <el-table :data="complianceResultData" style="width: 100%" :show-header="false" border>
                <el-table-column prop="label" width="200"></el-table-column>
                <el-table-column>
                    <template slot-scope="scope">
                        <!-- 如果是合规报告，则显示为链接 -->
                        <div v-if="scope.row.label === '合规报告'">
                            <div v-for="(item, index) in getFileList(scope.row.value)" :key="index" class="file-item">
                                {{ item }}

                                <el-button v-if="isPreviewable(item)" type="text" size="mini" @click="previewFile(item)"
                                    style="margin-left: 8px;">
                                    预览
                                </el-button>
                                <el-button type="text" size="small" @click="downloadFile(scope.row.value)">
                                    下载
                                </el-button>
                            </div>
                        </div>
                        <!-- 如果是审核意见，则显示为普通文本 -->
                        <div v-else>
                            {{ scope.row.value }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>

        <div style="margin-top: 30px; text-align: center;">
            <el-button type="danger" size="medium" @click="close('/DataComplianceManager')" style="width: 80px;">
                关闭
            </el-button>
        </div>

        <!-- 文件预览组件 -->
        <file-preview ref="filePreview" download-base-url="/web/dataComplianceDetail/download" />
    </div>
</template>
<script>
import FilePreview from '@/components/FilePreview.vue';

export default {
    name: 'DataComplianceDetailManager',
    components: {
        FilePreview
    },
    data() {
        return {
            dataComplianceInfoData: null,
            enterpriseInfoData: [],
            dataAssetInfoData: [],
            companyComplianceData: [],
            dataComplianceData: [],
            complianceResultData: []
        }
    },
    created() {
        // 从路由中获取传递的参数
        this.registrationId = this.$route.query.registrationId || '';

        if (this.registrationId) {
            this.initializeApplication();
        }
    },
    methods: {
        initializeApplication() {
            // 获取数据质量详情数据
            this.getRequest(`/web/dataComplianceDetail/query?registrationId=${this.registrationId}`)
                .then(resp => {
                    if (resp.data && resp.data.object) {
                        this.dataComplianceInfoData = resp.data.object;
                        // console.log("数据质量详情数据:");
                        // console.log(this.dataComplianceInfoData);

                        // 企业合规信息
                        this.companyComplianceData = [
                            { label: '资质证明材料', value: this.dataComplianceInfoData.qualificationMaterials },
                        ];

                        // 数据合规信息
                        this.dataComplianceData = [
                            { label: '数据来源', value: this.dataComplianceInfoData.dataSourceMaterials },
                            { label: '数据脱敏处理', value: this.dataComplianceInfoData.dataSampleMaterials },
                            { label: '数据存储安全', value: this.dataComplianceInfoData.dataStorageMaterials }
                        ];

                        // 审核结果
                        this.complianceResultData = [
                            { label: '审核意见', value: this.dataComplianceInfoData.platformReviewComments },
                            { label: '合规报告', value: this.dataComplianceInfoData.platformComplianceReport }
                        ];
                    }
                })
                .catch(error => {
                    console.error('获取数据失败:', error);
                });
            // 获取企业信息
            this.getRequest(`/web/companyInfo/queryByRegistrationId?registrationId=${this.registrationId}`)
                .then(resp => {
                    if (resp.data) {
                        // console.log("获取企业信息:");
                        // console.log(resp.data);

                        this.enterpriseInfoData = [
                            { label: '企业名称', value: resp.data.companyName },
                            { label: '统一社会信用代码', value: resp.data.socialCreditCode },
                            { label: '经营范围', value: resp.data.businessNature },
                            { label: '联系人姓名', value: resp.data.contactsName },
                            { label: '联系电话', value: resp.data.contactsPhone }
                        ];

                    }
                })
                .catch(error => {
                    console.error('获取数据失败:', error);
                });
            // 查询数据资产信息
            this.getRequest(`/web/dataAssets/queryByRegistrationId?registrationId=${this.registrationId}`)
                .then(resp => {
                    if (resp.data) {
                        // console.log("查询数据资产信息:");
                        // console.log(resp.data);

                        // 数据资产信息
                        this.dataAssetInfoData = [
                            { label: '数据资产名称', value: resp.data.assetName },
                            { label: '数据来源', value: resp.data.dataSource },
                            { label: '所属行业', value: resp.data.industry },
                            { label: '更新周期', value: resp.data.updateCycle },
                            { label: '数据覆盖地域', value: resp.data.region },
                            { label: '应用场景描述', value: resp.data.scenario },
                            { label: '数据资产简介', value: resp.data.description }
                        ];

                    }
                })
                .catch(error => {
                    console.error('获取数据失败:', error);
                });
        },
        // 文件下载
        async downloadFile(filename) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/dataComplianceDetail/download?registrationId=' + this.registrationId + '&fileName=' + filename,
                    responseType: 'blob'
                });

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },
        // 获取文件列表（处理字符串或数组）
        getFileList(fileValue) {
            if (!fileValue) return [];

            if (Array.isArray(fileValue)) {
                return fileValue;
            }

            if (typeof fileValue === 'string') {
                // 如果是逗号分隔的文件名，分割成数组
                return fileValue.split(',').map(item => item.trim()).filter(item => item);
            }

            return [fileValue];
        },
        // 判断文件是否可以预览
        isPreviewable(fileName) {
            if (!fileName) return false;

            // 确保fileName是字符串
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) return false;

            const ext = this.getFileExtension(fileNameStr);
            const previewableTypes = [
                'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', // 图片
                'pdf', // PDF
                'xls', 'xlsx', 'csv', // Excel文件
                'doc', 'docx', // Word文档
                'txt', 'json', 'xml', 'csv', 'log', 'js', 'css', 'html', 'md' // 文本文件
            ];
            return previewableTypes.includes(ext);
        },
        // 获取文件扩展名
        getFileExtension(filename) {
            if (!filename) return '';
            const parts = String(filename).split('.');
            return parts.length > 1 ? parts.pop().toLowerCase() : '';
        },
        // 预览文件
        async previewFile(fileName) {
            const fileNameStr = String(fileName).trim();
            if (!fileNameStr) {
                this.$message.warning('文件名不能为空');
                return;
            }

            this.isPreviewLoading = true;
            try {
                await this.$refs.filePreview.openPreview(
                    { fileName: fileNameStr },
                    this.registrationId
                );
            } catch (error) {
                console.error('预览失败:', error);
                this.$message.error('文件预览失败: ' + (error.message || ''));
            } finally {
                this.isPreviewLoading = false;
            }
        },
        // 关闭组件
        close(targetPage = '/home') {
            const fullPath = this.$route.fullPath;
            const currentPath = this.$route.path;

            // 1. 先跳转到指定页面
            if (currentPath !== targetPage) {
                this.$router.push(targetPage).then(() => {
                    // 2. 跳转成功后延迟关闭当前标签页
                    setTimeout(() => {
                        this.closeTab(fullPath);
                    }, 100);
                }).catch(() => {
                    // 跳转失败时仍然尝试关闭
                    this.closeTab(fullPath);
                });
            } else {
                // 如果已经在目标页面，直接关闭
                this.closeTab(fullPath);
            }
        },

        // 提取关闭标签页的公共方法
        closeTab(fullPath) {
            this.$emit('close-tab', fullPath);

            let parent = this.$parent;
            while (parent) {
                if (typeof parent.removeTab === 'function') {
                    parent.removeTab(fullPath);
                    break;
                }
                parent = parent.$parent;
            }
        },

    }
}
</script>

<style scoped>
.data-evaluation-page {
    padding: 15px;
    background-color: #f5f5f5;
}

.box-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.box-card>>>.el-card__header {
    background-color: #f0f0f0;
    font-weight: bold;
    font-size: 16px;
    color: #333;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.el-form-item {
    margin-bottom: 10px;
}

.el-form-item>>>.el-form-item__label {
    color: #666;
    font-weight: normal;
}
</style>